import axios from 'axios';
import { angularService, getAuthHeader } from '../../../utils';

export const getCustomComponents = () => {
  const zStatus = angularService('zStatus');
  const URL = zStatus && zStatus.endpoint && zStatus.endpoint.de && (zStatus.endpoint.de + '/components');
  return axios.get(URL, {
    headers: getAuthHeader()
  });
};
